import { FC, ReactNode } from 'react';
import { styled } from 'styled-components';
import { ISrcUrl } from '../MediaComp/helper';
import Image from '../MediaComp/Image';
import { $height, $width, phoneSize } from '@/assets/styles/mediaSize';
import { useLang } from '@/locales/useLang';
import { callFromExternal } from '@/utils';
import { getValue } from '@/externalConfig/conf'

interface ICustomerMessageProps {
  msgBody: string;
  className?: string;
}

interface ICustomerMsgBody {
  username: string;
  faceUrl: ISrcUrl;
  joinTime: string;
}

const CustomerMessageWrap = styled.div`
  width: fit-content;
  margin: 0 auto 0;
  padding: 16rem 8rem 8rem;
  position: relative;
  background-color: #fff;
  text-align: center;
  border-radius: 12rem;

  @media (max-width: ${phoneSize}) {
    padding: 32rem 16rem 16rem;
  }

  .icon-customer-avatar-wrap {
    /* width: 32rem;
    height: 32rem; */
    ${$width('64rem', '32rem')}
    ${$height('64rem', '32rem')}
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;

    .icon-customer-avatar {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
`;

const CustomerMessage: FC<ICustomerMessageProps> = (props) => {
  const $t = useLang();

  const msgBodyInfo = useMemo(() => {
    const defaultAvatar = require('@img/chat/icon-default-customer.png');
    let _msgBody = {
      username: $t('chat_session_status_1'),
      faceUrl: defaultAvatar,
      joinTime: '',
    };
    try {
      const temp = JSON.parse(props.msgBody);
      const _avatar = JSON.parse(temp.faceUrl);
      _msgBody = temp;

      if (!_avatar?.url) {
        _msgBody.faceUrl = defaultAvatar;
      }
    } catch (error) {}

    return _msgBody;
  }, [props.msgBody]);
  const external = callFromExternal()
  return (
    <CustomerMessageWrap className={external ? 'external-custom-wrap' : props.className}>
      <div className={`icon-customer-avatar-wrap ${external ? 'external-custom-avatar-wrap' : ''}`}>
        <Image src={external ? getValue('robotAvatar') : msgBodyInfo.faceUrl} className="icon-customer-avatar" />
      </div>
      <div>
        <span>{msgBodyInfo.username}</span>
        <span className="ml-5">{$t('chat_session_status_4')}</span>
      </div>
    </CustomerMessageWrap>
  );
};

export default CustomerMessage;
